import { useCallback } from 'react';
import { Button, Menu, MenuContent, MenuTrigger, MenuItem } from '@cad-arc';
import { InitiateSubmenuView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { useOpenEventPanel } from '../../../../event-panel/use-open-event-panel';
import { getSelfInitiateOptions } from '../../../../common/helpers/self-initiate-options';

export function UnitPanelInitiateButton({
    initiateSubmenuView,
    clickParams,
}: {
    initiateSubmenuView: InitiateSubmenuView;
    clickParams: UnitContextMenuClickParams;
}) {
    const openEventPanel = useOpenEventPanel();

    const {
        isEnabled,
        label,
        initiateAttributeOptions,
        initiateCallForServiceOptions,
    } = initiateSubmenuView;

    const options = [...initiateCallForServiceOptions, ...initiateAttributeOptions];

    const handleSelect = useCallback(
        (selfInitiateAttrId: number) => {
            clickParams.unitId &&
                openEventPanel({
                    workspacePanelConfig: {
                        panelState: {
                            selfInitiate: {
                                ...getSelfInitiateOptions(initiateSubmenuView, selfInitiateAttrId),
                                unitId: clickParams?.unitId,
                            },
                        },
                    },
                });
        },
        [clickParams.unitId, initiateSubmenuView, openEventPanel]
    );

    return (
        <Menu isModal={false}>
            <MenuTrigger asChild>
                <Button trailingVisual="Open" disabled={!isEnabled}>
                    {label}
                </Button>
            </MenuTrigger>
            <MenuContent>
                {options.map(({ value, label }) => (
                    <MenuItem key={value} onSelect={() => handleSelect(value)}>
                        {label}
                    </MenuItem>
                ))}
            </MenuContent>
        </Menu>
    );
}
